export const navlinks=[
    {
        name:'Education',
        slug:'education'
    },
    {
        name:'Technology',
        slug:'technology'
    },
    {
        name:'Travel',
        slug:'travel'
    },
    {
        name:'Digital Marketing',
        slug:'digital-marketing'
    },
    {
        name:'Business & Services',
        slug:'business-services'
    },
    {
        name:'Real State',
        slug:'real-state'
    },
    {
        name:'Banking & Finance',
        slug:'banking'
    },
    {
        name:'Fashion',
        slug:'fashion'
    },
    {
        name:'Health & Fitness',
        slug:'health-fitness'
    },
    {
        name:'News',
        slug:'news'
    },
    {
        name:'Entertainment',
        slug:'entertainment'
    },
    {
        name:'Autos & Vehicle',
        slug:'auto-vehicle'
    },

]

// @ts-ignore
export const dummyArray=[...Array(10).keys()];